import {
  CrownOutlined,
  DeleteOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { Flex, Checkbox, Button, Upload } from "antd";
import "./GalleryHeader.scss";
import Helpers from "@utils/Helpers";
import { IGalleryHeader } from "@utils/Interfaces";

const GalleryHeader: React.FC<IGalleryHeader> = ({
  type,
  checkAll,
  setCheckAll,
  handleDelete,
  handleOnChange,
}) => {
  return (
    <div className="GalleryHeader">
      <Flex gap={12}>
        <Checkbox
          checked={checkAll}
          onChange={(e) => {
            if (e.target.checked) {
              setCheckAll(true);
            } else {
              setCheckAll(false);
            }
          }}
        />
        <Button
          className="upgrade-btn"
          variant="filled"
          icon={<CrownOutlined />}
        >
          Premium
        </Button>
        <Button
          className="delete-btn"
          icon={<DeleteOutlined />}
          variant="filled"
          color="danger"
          onClick={handleDelete}
        >
          Delete
        </Button>
        <Upload
          multiple
          name="file"
          onChange={handleOnChange}
          customRequest={() => {
            return;
          }}
          showUploadList={false}
        >
          <Button
            className="upload-btn"
            icon={<UploadOutlined />}
            variant="filled"
          >
            Upload
          </Button>
        </Upload>
      </Flex>
    </div>
  );
};

export default GalleryHeader;
